import {Article} from "./article.model";

export class PageTypeGroup {
  pageTypeCode?: string;
  articles?: Article[];
}
